'use client';

import { Stack, Unstable_Grid2 as Grid, Box, Typography, Button } from '@mui/material';
import { numberSeparator } from 'number-separator-js';
import { IconSvg } from '@/components/Icon';
import Container from '@/components/layout/Container';
import Section from '@/components/Section';
import { useSummeryInvestments } from '@/api/hooks/useSummeryInvestments';
import HeroHistoryItem from '@/components/item/HeroHistoryItem';
import WhatZeemaAndHowToWork from '@/containers/home/components/WhatZeemaAndHowToWork';
import { scrollToId } from '@/utils/function';
const texts = {
  title: 'سود فردی، رشد جمعی',
  desc: 'با زیما، سرمایه‌های خرد شما به پروژه‌هایی با تأثیر اجتماعی بزرگ تبدیل می‌شود.',
  btn1Title: 'دیدن فرصت‌های سرمایه‌گذاری'
};
const IntroHeader = () => {
  const {
    data
  } = useSummeryInvestments();
  const items = [{
    icon: <IconSvg component='TotalIncome' width='40' height='40' />,
    title: 'مجموع سرمایه‌گذاری   ',
    subTitle: data ? `${numberSeparator({
      text: (+(data.users_investments_sum || 0)).toString()
    })}` : '-',
    preValue: 'تومان'
  }, {
    icon: <IconSvg component='TotalProfit' width='40' height='40' />,
    title: 'مجموع سود دریافتی ',
    subTitle: data ? `${numberSeparator({
      text: (+(data.received_profits_sum || 0)).toString()
    })}` : '-',
    preValue: 'تومان'
  }, {
    icon: <IconSvg component='TotalInvestor' width='40' height='40' />,
    title: 'سرمایه‌گذاران',
    subTitle: data ? `${numberSeparator({
      text: (+(data.investors_count || 0)).toString()
    })}` : '-',
    preValue: 'کاربر'
  }];
  return <Box sx={{
    background: 'linear-gradient(180deg, rgb(255 255 255) 25%, rgb(229 242 255) 100%)'
  }} data-sentry-element="Box" data-sentry-component="IntroHeader" data-sentry-source-file="IntroHeader.tsx">
      <Container data-sentry-element="Container" data-sentry-source-file="IntroHeader.tsx">
        <Grid container spacing={{
        xs: 'var(--spacing_l)',
        md: 'var(--spacing_xxxl)'
      }} data-sentry-element="Grid" data-sentry-source-file="IntroHeader.tsx">
          <Grid xs={12} md={8} data-sentry-element="Grid" data-sentry-source-file="IntroHeader.tsx">
            <Section sx={{
            gap: {
              xs: 'var(--spacing_xl)',
              md: 'var(--spacing_m)'
            },
            py: {
              xs: 'var(--spacing_l)',
              md: 'var(--spacing_xxxl)'
            }
          }} data-sentry-element="Section" data-sentry-source-file="IntroHeader.tsx">
              <Stack sx={{
              alignItems: {
                xs: 'center',
                md: 'flex-start'
              },
              gap: 'var(--spacing_xs)'
            }} data-sentry-element="Stack" data-sentry-source-file="IntroHeader.tsx">
                <Typography typography={{
                xs: 'titleStrong__Wallfund',
                md: 'displayStrong__Wallfund'
              }} component='h1' data-sentry-element="Typography" data-sentry-source-file="IntroHeader.tsx">
                  {texts.title}
                </Typography>
                <Typography sx={{
                typography: {
                  xs: 'bodyLargeRegular__Wallfund',
                  md: 'headlineRegular__Wallfund'
                },
                textAlign: 'center'
              }} component='h2' color='text.text2' data-sentry-element="Typography" data-sentry-source-file="IntroHeader.tsx">
                  {texts.desc}
                </Typography>
              </Stack>

              <Stack sx={{
              flexDirection: {
                xs: 'column',
                md: 'column-reverse'
              },
              alignItems: {
                xs: 'center',
                md: 'flex-start'
              },
              gap: {
                xs: 'var(--spacing_xl)',
                md: 'var(--spacing_xxxl)'
              }
            }} data-sentry-element="Stack" data-sentry-source-file="IntroHeader.tsx">
                <Stack sx={{
                alignItems: {
                  xs: 'center',
                  md: 'flex-start'
                }
              }} gap='var(--spacing_xs)' data-sentry-element="Stack" data-sentry-source-file="IntroHeader.tsx">
                  <Typography sx={{
                  typography: 'bodyLargeStrong__Wallfund',
                  color: 'text.text2'
                }} data-sentry-element="Typography" data-sentry-source-file="IntroHeader.tsx">
                    زیما چیست و چگونه کار می‌کند؟
                  </Typography>
                  <WhatZeemaAndHowToWork data-sentry-element="WhatZeemaAndHowToWork" data-sentry-source-file="IntroHeader.tsx" />
                </Stack>
                <Button variant='contained' size='large' onClick={() => scrollToId('plans', 50)} sx={{
                maxWidth: 228
              }} data-sentry-element="Button" data-sentry-source-file="IntroHeader.tsx">
                  {texts.btn1Title}
                </Button>
              </Stack>
            </Section>
          </Grid>

          <Grid xs={12} md={4} data-sentry-element="Grid" data-sentry-source-file="IntroHeader.tsx">
            <Stack gap='var(--spacing_m)' py='var(--spacing_xxl)' data-sentry-element="Stack" data-sentry-source-file="IntroHeader.tsx">
              {items.map((item, idx) => {
              return <HeroHistoryItem key={`item-${idx}`} icon={item.icon} title={item.title} subTitle={item.subTitle} preValue={item.preValue} />;
            })}
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </Box>;
};
export default IntroHeader;